import { StatusCodes } from 'http-status-codes';
import type { RouteMiddleware } from 'nuxt/app';
import { defineNuxtRouteMiddleware } from '#imports';
import { enhancedNavigateTo } from '~/utils/enhancedNavigateTo';
import { shouldSkipMiddleware } from '~/utils/routing/routeExclusions';
import { matchAllTrailingSlashes } from '~~/lib/regexes';

export const trailingSlashHandlerMiddleware: RouteMiddleware = (to) => {
  if (shouldSkipMiddleware(to.path)) {
    return;
  }

  let redirectPath: string | undefined;

  if (!to.path.endsWith('/')) {
    redirectPath = `${to.path}/`;
  } else if (matchAllTrailingSlashes.test(to.path)) {
    redirectPath = to.path.replace(matchAllTrailingSlashes, '/');
  }

  if (redirectPath) {
    return enhancedNavigateTo(
      {
        query: to.query,
        path: redirectPath
      },
      {
        replace: true,
        redirectCode: StatusCodes.MOVED_PERMANENTLY
      }
    );
  }
};

export default defineNuxtRouteMiddleware(trailingSlashHandlerMiddleware);
